// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cashCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0.5rem 1.625rem;
  text-align: center;
  border-radius: 0.313rem;
  cursor: pointer;
  height: 100%;
  transition: background-color 0.3s;
}
@media screen and (max-width: 767.98px) {
  .cashCard {
    padding: 1.5rem 0.5rem 1.25rem;
  }
}
.cashCard-icon {
  height: 32px;
  width: 32px;
  border-radius: 100%;
  margin: 0 auto 0.625rem;
}
.cashCard-icon img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.cashCard h4 {
  color: var(--white);
  margin: 0;
  font-weight: 700;
  font-size: 1rem;
}
@media screen and (max-width: 767.98px) {
  .cashCard h4 {
    font-size: 0.8125rem;
  }
}
.cashCard p {
  color: var(--gray-40);
  text-transform: capitalize;
  margin: 0;
  font-size: 0.875rem;
}
@media screen and (max-width: 767.98px) {
  .cashCard p {
    font-size: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui-kit/CashCard/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,iCAAA;AAAF;AAEE;EAbF;IAcI,8BAAA;EACF;AACF;AAKE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAKI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAHN;AAOE;EACE,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAOI;EANF;IAOI,oBAAA;EAJJ;AACF;AAOE;EACE,qBAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AALJ;AAOI;EANF;IAOI,kBAAA;EAJJ;AACF","sourcesContent":[".cashCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  // background: var(--gray-85);\n  padding: 2rem .5rem 1.625rem;\n  text-align: center;\n  border-radius: 0.313rem;\n  cursor: pointer;\n  height: 100%;\n  transition: background-color 0.3s;\n\n  @media screen and (max-width: 767.98px) {\n    padding: 1.5rem .5rem 1.25rem;\n  }\n\n  // &:hover {\n  //   background: var(--gray-80);\n  // }\n\n  &-icon {\n    height: 32px;\n    width: 32px;\n    border-radius: 100%;\n    margin: 0 auto 0.625rem;\n\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n  }\n\n  h4 {\n    color: var(--white);\n    margin: 0;\n    font-weight: 700;\n    font-size: 1rem;\n\n    @media screen and (max-width: 767.98px) {\n      font-size: 0.8125rem;\n    }\n  }\n\n  p {\n    color: var(--gray-40);\n    text-transform: capitalize;\n    margin: 0;\n    font-size: 0.875rem;\n\n    @media screen and (max-width: 767.98px) {\n      font-size: 0.75rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
